<div id="wrapper">
  <app-loading-screen [status]=true></app-loading-screen>
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive"></app-menu>
    <div class="basicrow mbott">
      <div class="container">
        <div class="fulltitle m-top-i f-btitle">
          <img width="100%" class="userimgicon" src="../../../assets/images/usersvicon.png"> Detalle del Suscriptor
        </div>
        <div *ngIf="this.info!=''">
          <div class="fulltitleRight m-top-i f-btitle caja2">
            <div class="txt-type"
              *ngIf="this.typeAccount=='Movil'">
              <i class="fa fa-mobile esp" aria-hidden="true"></i>
              MÓVIL {{this.subscriberP}}
            </div>
            <div class="txt-type" *ngIf="this.typeAccount=='Satelite'">
              <i class="fa fa-mobile esp" aria-hidden="true"></i>
              SATÉLITE {{this.subscriberP}}
            </div>
            <div class="txt-type"
            *ngIf="this.typeAccount=='Fijo'">
              <i class="fa fa-phone esp" aria-hidden="true"></i>
              FIJO {{this.subscriberP}}
            </div>
          </div>
          <div *ngIf="this.ini==true">
            <app-equipment-info 
              [dateWarranty]="this.dateWarranty" [typeAccount]="this.typeAccount"
              [mobile_image]="this.itemImageField" [equipment_name]="this.itemDescriptionField"
              [techField]="this.techField" [val_ins_equ]="this.installmentValueField"
              [instal_equ]="this.installmentsField" [itemBrandField]="this.itemBrandField" [index]="this.index">
            </app-equipment-info>
            <app-plan-info [plan_name]="this.sOCDescriptionField" [plan_price]="this.socRateField"
              [plan_description]="this.sOCDescriptionInfoField" [additional_serv]="this.servSVAsField"
              [totalRateField]="this.totalRateField" [typeAccount]="this.typeAccount"></app-plan-info>
            <app-usage-info [minutesUsageField]="this.minutesUsageField" [lDUsageField]="this.lDUsageField"
              [lDIUsageField]="this.lDIUsageField" [sMSUSageField]="this.sMSUSageField"
              [sMSPremiunUsageField]="this.sMSPremiunUsageField" [mMSUsageField]="this.mMSUsageField" [index]="this.index"
              [info]="this.info" [productType]="this.productType" [typeAccount]="this.typeAccount">
            </app-usage-info>
          </div>
        </div>
        <div *ngIf="this.info==''">
          <div class="fulltitleRight m-top-i f-btitle caja3">
            No hay datos para mostrar
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>